"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UintField = void 0;
const register_1 = require("../../register");
const bignumber_1 = require("@ethersproject/bignumber");
const UintField = (size, byteorder = "big") => {
    const serializer = {
        serialize: (value, buf) => {
            value = bignumber_1.BigNumber.from(value);
            let s = value.toHexString().slice(2);
            if (s.length < size / 4) {
                const diff = size / 4 - s.length;
                s = "0".repeat(diff) + s;
            }
            if (byteorder === "little") {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                s = s.match(/../g).reverse().join("");
            }
            const buf2 = Buffer.from(s, "hex");
            return Buffer.concat([buf, buf2]);
        },
        deserialize: (buf) => {
            const numOfBytes = size / 8;
            if (buf.length < numOfBytes)
                throw new Error();
            const buf2 = buf.slice(0, numOfBytes);
            buf = buf.slice(numOfBytes);
            let num;
            if (byteorder === "little") {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                num = bignumber_1.BigNumber.from("0x" + Buffer.from(buf2.toString("hex").match(/../g).reverse().join("")));
            }
            else {
                num = bignumber_1.BigNumber.from("0x" + buf2.toString("hex"));
            }
            return [num, buf];
        },
    };
    return (0, register_1.buildField)(serializer)();
};
exports.UintField = UintField;
//# sourceMappingURL=uint.js.map